import { useContext, useEffect } from "react";
import "./updateCatalog.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";


// context
import { AuthContext } from "../../../../contexts/authContext";

// ui-component
import GoBack from '../../../../components/UI/GoBack/GoBack';

// component
import QuestionCatalogForm from '../../../../components/QuestionCatalogForm/QuestionCatalogForm';

const API_URL = "/api/v1";
const UpdateCatalog = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const fetchUserRole = async () => {
    try {
      const res = await axios.get(`${API_URL}/auth/role/${user.id}`);
      if (res.status === 200 && res.data.success === true) {
        if(user && res.data.role === "user"){
            navigate("/dashboard/evaluation")
        }
        
      } 
    } catch (error: any) {
      console.log("Error fetching user role", error);
    }
  };

  useEffect(() => {
    fetchUserRole();
    // eslint-disable-next-line
  }, []);
  return (
    <div className='updateCatalog'>
        <div className="container">
            <div className="appbar">
                <GoBack goback="/dashboard/catalog" />
                <span className="title">Create Catalog</span>
            </div>
            <QuestionCatalogForm edit={true}/>
        </div>
    </div>
  )
}

export default UpdateCatalog